import { queryOptions } from '@tanstack/react-query';
import { usersControllerGetMeV1 } from '@/api/generated/users/users';

export const currentUserKeys = {
  all: ['currentUser'] as const,
  detail: () => [...currentUserKeys.all, 'detail'] as const,
};

/**
 * The signed-in user's profile, as one reusable query definition.
 *
 * Lives in `lib/` rather than in the auth module because the route guards in
 * `app/routes` need it too, and `app/routes` cannot import from a module that
 * imports it back (every module's routes file imports the layout routes).
 * The auth module's hooks re-export the keys so nothing else has to know.
 *
 * Never retried: this call is also how a bad token is discovered, and the 401
 * handler in `@/api/client` has already cleared the session and redirected by
 * the time it would retry.
 */
export function currentUserQueryOptions() {
  return queryOptions({
    queryKey: currentUserKeys.detail(),
    queryFn: () => usersControllerGetMeV1(),
    retry: false,
    staleTime: 5 * 60 * 1000,
  });
}
